export default [
  {
    path: '/customer-manage',
    name: 'customer-manage',
    component: resolve => require(['views/customer-manage'], resolve),
    meta: { auth: true, view: 'pc' }
  },
  {
    path: '/customer-manage/customer-form/:isEdit/:id',
    props: true,
    name: 'customer-form',
    component: resolve => require(['views/customer-form'], resolve),
    meta: { auth: true, view: 'pc', navInfo: '客户管理/客户', isForm: true }
  },
  {
    path: '/customer-detail/:id',
    name: 'customer-detail',
    component: resolve => require(['views/customer-detail'], resolve),
    meta: { auth: true, view: 'pc', navInfo: '客户管理/客户详情' }
  },
  {
    path: '/roles-permissions',
    props: true,
    name: 'user-roles',
    component: resolve => require(['views/user-roles'], resolve),
    meta: { auth: true, view: 'pc' }
  },
  {
    path: '/roles-permissions/roles-form/:isEdit/:id',
    name: 'roles-form',
    props: true,
    component: resolve => require(['views/roles-form'], resolve),
    meta: { auth: true, view: 'pc', navInfo: '用户权限/角色', isForm: true }
  },
  {
    path: '/customer-of-system',
    name: 'customer-of-system',
    component: resolve => require(['views/customer-of-system'], resolve),
    meta: { auth: true, view: 'pc' }
  },
  {
    path: '/system-customer-form/:isEdit/:userLogin',
    name: 'system-customer-form',
    props: true,
    component: resolve => require(['views/system-customer-form'], resolve),
    meta: { auth: true, view: 'pc', navInfo: '系统用户管理/用户', isForm: true }
  },
  {
    path: '/system-user-detail/:id',
    name: 'system-user-detail',
    props: true,
    component: resolve => require(['views/system-user-detail'], resolve),
    meta: { auth: true, view: 'pc', navInfo: '系统用户管理/用户', isForm: true }
  },
]
